module.exports = __webpack_public_path__ + "img/smartTutoring1.563a6292.png";